import { render, staticRenderFns } from "./CastJoin.vue?vue&type=template&id=0e8971a1&scoped=true&"
import script from "./CastJoin.vue?vue&type=script&lang=js&"
export * from "./CastJoin.vue?vue&type=script&lang=js&"
import style0 from "./CastJoin.vue?vue&type=style&index=0&id=0e8971a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8971a1",
  null
  
)

export default component.exports